import axios from 'axios'
import authApi from  '@/services/AuthTokenApiClient.js'
import store from '@/store'

const baseURL = process.env.VUE_APP_BEAPI;
const apiVersion =  process.env.VUE_APP_API_VERSION ? `/${process.env.VUE_APP_API_VERSION}` : '';

axios.defaults.withCredentials = true
let client = axios.create({
  baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
       withCredentials: true,
       crossDomain: true
   }
})


export default {
  async verify(regToken, apiKey){
    return client.post(`/customer${apiVersion}/users/me/verify`, {regToken, apiKey});
  },
  async sendRemindMeEmail(email){
    let token = await authApi.getAccessToken();

    let defaultOptions = {
      headers:{
        'Authorization': 'Bearer ' + token
      }
    };
    let data = {
      EmailAddress: email
    }
    return client.post(`/recovery${apiVersion}/email/remindme`, data, defaultOptions);
  },
  async setEmailReminder(email){
    try{

      let data = {
        EmailAddress: email
      }
      return client.post(`/customer${apiVersion}/users/me/cards/remindme`, data).then((response)=>{
        if(response.status === 204)
        {
          return response.status;
        }else
        {
          return -1;
        }
      });
    }
    catch (error) {
      console.log(error);
      throw(error);
    }
  },
  async registerUser(user)
  {
    try{
      
      let data = {
        Title: user?.title ?? "", 
        FirstName: user?.firstName,
        LastName: user?.lastName,
          EmailAddress: user?.email,
          Password: user?.password,
          MarketingOptIn: user?.marketingOptIn,
          RewardsCardNumber: user?.rewardsCardNumber,
          SignUpSource: user?.source,
          RequestType: user?.requestType,
          PromoCode: user?.promoCode,
          joinBeautyClub: user?.joinBeautyClub == 'mybeauty',
        CreationSource: "DigitalRewards"
      };

      
      if (user?.joinBeautyClub === 'mybeauty') {
        data.excludeFromBeautyMarketing = !marketingOptIn;
      }
      
      return client.post(`/registration${apiVersion}/users`, data).then((response)=>{
        if(response.status === 200 && response.data.Status === 3) 
        {
          return {Status: response.data.Status, Message: response.data.Response};
        }
        else if(response.status === 200)
        {
          return response.data;
        }
        else
        {
          return -1;
        }
        
      });
    }
    catch (error) {
      console.log(error);
      throw(error);
    }
  },

  async joinMyBeauty(customerId, excludeFromMarketing) {

    let data = {
      customerId: customerId,
      excludeFromMarketing: excludeFromMarketing,
      clubTCAgreed: true
    };

    let token = await this.getBearerToken();
    let defaultOptions = {
      headers: {
      'Authorization': 'Bearer ' + token
      }
    };

    return client.post(`/registration${apiVersion}/users/beauty-club/join`, data, defaultOptions);
  },

  async authUser(emailAddress, password, scope = null)
  {
    try{
    let data = {username: emailAddress, password: password}

    if (scope) {
      data.scope = scope;
    }
    
    return client.post('/auth', data).then((response)=> {
      if(response.status === 200)
      {
        store.dispatch('saveAccessToken', response.data.access_token);
        return 1;
      }
    })
    .catch((error)=> {
      console.log(error);
      if(error.response.status === 404)
      {
        return -1;
      }
      else if(error.response.data.custom_error?.error_code)
      {
        return error.response.data.custom_error.error_code;
      }
      else if(error.response.data.custom_error?.error)
      {
        return error.response.data.custom_error.error;
      }
      throw(error);
    });
  }catch (error) {
      console.log(error);
      throw(error)
    }
  },

  async upgradeUser(user, cardNumber, source, joinMyBeauty = false, excludeFromBeautyMarketing = false)
  {
    try{
      let token = await this.getBearerToken();

    let defaultOptions = {
      headers: {
       // withCredentials: true,
       // crossDomain: true,
      'Authorization': 'Bearer ' + token
      }
      };
    let data = {
      Title: user.title, 
       FirstName: user.firstName,
       LastName: user.lastName, 
       EmailAddress: user.email, 
       Password: '',
       MarketingOptIn: !joinMyBeauty,  /*TODO: MarketingOptIn needs to be discussed with B*/
       RewardsCardNumber: cardNumber,
       SignUpSource: source ?? 'CN',
       RequestType: !cardNumber ? 0 : 1,
       joinBeautyClub: joinMyBeauty,
       excludeFromBeautyMarketing,
       CreationSource: "DigitalRewards"
      }
    return client.post(`/registration${apiVersion}/users`, data, defaultOptions).then((response)=> {
      if(response.status === 200 && response.data.Status === 2)
      {
        return 1;
      }else
      {
          return 0;
      }
    })
    .catch((error)=> {
      console.log(error);
      if(error.response.status === 404)
      {
        return -1;
      }
    });
  }catch (error) {
      console.log(error);
      throw(error);
    }
  },

  async clearUser() {
    try {
      
      let token = await this.getBearerToken();

      // document.cookie = "name=AUTHCRM; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/"

      let defaultOptions = {
        headers: {
        // withCredentials: true,
        // crossDomain: true,
        'Authorization': 'Bearer ' + token
        }
      };

      let data = {}
      return client.post(`/auth${apiVersion}/sign-out`, data, defaultOptions)

    } catch (error) {
      console.log(error);
      throw(error);
    }
  },

  async getUser(accessKey, oatToken)
  {
    try{
      let token = await this.getBearerToken();
      client = axios.create({
        baseURL,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
             withCredentials: true,
             crossDomain: true,
             'Cache-Control': 'no-cache'
         }
      })
    let defaultOptions = {
      headers: {
      withCredentials: true,
    //  crossDomain: true,
      }
      };

    let oatEndpoint = '';
    if (accessKey) {
      defaultOptions.headers['Api-Hrd-User-Key'] = accessKey;
      oatEndpoint = '/' + oatToken;
    } else {
      defaultOptions.headers['Authorization'] = 'Bearer ' + token;
    }
    
    return client.post(`/customer${apiVersion}/users/me` + oatEndpoint, {}, defaultOptions).then((response)=> {
      if(response.status === 403)
      {
        return -1;
      }else if(response.data != null)
        {
          return response.data;
        }
    })
    .catch((error)=> {
      if(error.response.status === 500)
      {
        return -1;
      }
      if(error.response.status === 401)
      {

        //TODO: redirect to SignIn
        return 0;
      }
    });
  }catch (error) {
      console.log(error);
      throw(error);
    }
  },
  
  async getGoogleCardToken(customerId, accessKey, oatToken)
  {
    try{
      
    let token = await this.getBearerToken(accessKey);

    let defaultOptions = {
      headers: {
      'Authorization': 'Bearer ' + token
      }
      };
    let data = {customerId: customerId}

    let oatEndpoint = '';
    if (accessKey) {
      defaultOptions.headers['Api-Hrd-User-Key'] = accessKey;
      oatEndpoint = '/' + oatToken;
    }

    return client.post(`/wallet${apiVersion}/google-jwt` + oatEndpoint, data, defaultOptions).then((response)=> {
      if(response.status === 403)
      {
        return -1;
      }else if(response.data != null)
        {
          return response.data;
        }
    })
    .catch((error)=> {
      if(error.response.status === 500)
      {
        return -1;
      }
      if(error.response.status === 401)
      {

        //TODO: redirect to SignIn
        return 0;
      }
    });
  }catch (error) {
    /*if(error.response.status === 500)
      {
        return -1;
      }
    if(error.response.status === 401)
      {

        //TODO: redirect to SignIn
        return 0;
      }*/
      console.log(error);
      throw(error);
    }
  },
  
  async getAppleCardToken(customerId, accessKey, oatToken)
  {
    try{
      client = axios.create({
        baseURL,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
             withCredentials: true,
             crossDomain: true,
         },
         responseType: 'blob'
      })
      let token = await this.getBearerToken(accessKey);

    let defaultOptions = {
      headers: {
      'Authorization': 'Bearer ' + token
      },

      };
    let data = {customerId: customerId}

    let oatEndpoint = '';
    if (accessKey) {
      defaultOptions.headers['Api-Hrd-User-Key'] = accessKey;
      oatEndpoint = '/' + oatToken;
    }

    return client.post(`/wallet${apiVersion}/apple-pss` + oatEndpoint, data, defaultOptions).then((response)=> {
      if(response.status === 403)
      {
        return -1;
      }else if(response.data != null)
        {
          return response.data;
        }
    })
    .catch((error)=> {
      if(error.response.status === 500)
      {
        return -1;
      }
      if(error.response.status === 401)
      {

        //TODO: redirect to SignIn
        return 0;
      }
    });
  }catch (error) {
      console.log(error);
      throw(error);
    }
  },
  async cardDownloadLog(rewardsCardNumber, platform, deviceId, downloadReference, accessKey, oatToken)
  {
    try {
      let token = await this.getBearerToken(accessKey);

      let defaultOptions = {
        headers: {
        'Authorization': 'Bearer ' + token
        }
        };
      let data = {RewardsCardNumber: rewardsCardNumber, Platform: platform, DeviceId: deviceId, DownloadReference: downloadReference}
      
      let oatEndpoint = '';
      if (accessKey) {
        defaultOptions.headers['Api-Hrd-User-Key'] = accessKey;
        oatEndpoint = '/' + oatToken;
      }

      return client.post(`/wallet${apiVersion}/cards` + oatEndpoint, data, defaultOptions).then((response)=> {
        if(response.status === 403)
        {
          return -1;
        }else if(response.data != null)
          {
            return response.data;
          }
      })
      .catch(()=> {

      });
    }
    catch(error){
      console.log(error);
      throw(error);
    }
  },
  async getBearerToken() {
    return store.state.accessToken;
  }
}
